import { render } from "./PRsModal.vue?vue&type=template&id=ce2e9c52"
import script from "./PRsModal.vue?vue&type=script&lang=js"
export * from "./PRsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__